export const nationalities = [
  "Afghan","Albanian","Algerian","American","Andorran","Angolan","Argentine","Armenian",
  "Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian",
  "Belarusian","Belgian","Belizean","Beninese","Bhutanese","Bolivian","Bosnian","Brazilian",
  "British","Bruneian","Bulgarian","Burkinabe","Burmese","Burundian","Cambodian","Cameroonian",
  "Canadian","Cape Verdean","Central African","Chadian","Chilean","Chinese","Colombian",
  "Comorian","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish",
  "Djiboutian","Dominican","Dutch","East Timorese","Ecuadorian","Egyptian","Emirati",
  "Equatorial Guinean","Eritrean","Estonian","Ethiopian","Fijian","Filipino","Finnish",
  "French","Gabonese","Gambian","Georgian","German","Ghanaian","Greek","Grenadian",
  "Guatemalan","Guinean","Guyanese","Haitian","Honduran","Hungarian","Icelandic","Indian",
  "Indonesian","Iranian","Iraqi","Irish","Israeli","Italian","Ivorian","Jamaican","Japanese",
  "Jordanian","Kazakh","Kenyan","Kuwaiti","Kyrgyz","Lao","Latvian","Lebanese","Liberian",
  "Libyan","Lithuanian","Luxembourgish","Macedonian","Malagasy","Malawian","Malaysian",
  "Maldivian","Malian","Maltese","Mauritanian","Mauritian","Mexican","Moldovan","Mongolian",
  "Montenegrin","Moroccan","Mozambican","Namibian","Nepalese","New Zealander","Nicaraguan",
  "Nigerian","Nigerien","North Korean","Norwegian","Omani","Pakistani","Palestinian",
  "Panamanian","Paraguayan","Peruvian","Polish","Portuguese","Qatari","Romanian","Russian",
  "Rwandan","Saint Lucian","Salvadoran","Saudi","Senegalese","Serbian","Singaporean",
  "Slovak","Slovenian","Somali","South African","South Korean","South Sudanese","Spanish",
  "Sri Lankan","Sudanese","Surinamese","Swedish","Swiss","Syrian","Taiwanese","Tajik",
  "Tanzanian","Thai","Togolese","Trinidadian","Tunisian","Turkish","Turkmen","Ugandan",
  "Ukrainian","Uruguayan","Uzbek","Venezuelan","Vietnamese","Yemeni","Zambian","Zimbabwean"
];
